import { z } from "zod";

export const personalInfoSchema = z.object({
    name       : z
        .string()
        .min(2, "이름은 2자 이상이어야 합니다")
        .max(10, "이름은 10자 이하이어야 합니다")
        .nonempty("이름을 입력해주세요"),
    birth      : z
        .string()
        .regex(
            /^(19[0-9]{2}|20[0-9]{2})(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])$/,
            "생년월일을 8자리로 입력해주세요 (예: 19900101)"
        )
        .nonempty("생년월일을 입력해주세요"),
    email      : z
        .string()
        .email("이메일 형식으로 입력해주세요")
        .nonempty("이메일을 입력해주세요"),
    phoneNumber: z
        .string()
        .regex(/^010\d{8}$/, "전화번호 형식으로 입력해주세요 (예: 01012345678)")
        .nonempty("전화번호를 입력해주세요"),

    // 인증번호 검증 pass
    authNumber : z
        .string()
        .min(6, "인증번호는 6자리여야 합니다")
        .max(6, "인증번호는 6자리여야 합니다")
        .regex(/^[0-9]{6}$/, "숫자만 입력해주세요")
        .optional(),
});


// zod 라이브러리를 사용하여 입력된 개인정보 데이터를 검증하는 함수
export const validatePersonalInfo = (data) => {
    try {
        const validatedData = personalInfoSchema.parse(data);
        return { success: true, data: validatedData };
    } catch (error) {
        if (error instanceof z.ZodError) {
            const errors = error.errors.map((err) => ({
                path: err.path.join('.'),
                message: err.message,
            }));
            return { success: false, errors };
        }
        return { success: false, errors: [{ path: 'unknown', message: '알 수 없는 오류가 발생했습니다.' }] };
    }
};